import { render, staticRenderFns } from "./absencePermit.vue?vue&type=template&id=9af17ed8"
import script from "./absencePermit.vue?vue&type=script&lang=js"
export * from "./absencePermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports